import { Text } from "@merge-api/merge-javascript-shared";

interface Props {
  label: string;
  children: React.ReactNode;
}

// One labelled value in a speed card, shared by the account and organization
// cards so the resolution layers read the same in both.
const SpeedField = ({ label, children }: Props) => (
  <div>
    <Text variant="sm" className="mb-1 block text-gray-60">
      {label}
    </Text>
    {children}
  </div>
);

export default SpeedField;
